import { LoadingSection } from 'components/LoadingSection';
import { Layout } from 'layouts/Layout/Layout';

type Props = {
  navSection?: 'MAIN' | 'STAFF';
  noDelay?: boolean;
};

export function LoadingPage({ navSection, noDelay }: Props) {
  return (
    <Layout navSection={navSection}>
      <LoadingSection noDelay={noDelay} />
    </Layout>
  );
}
